import { transform, isEqual, isObject, mergeWith } from 'lodash';

export function _get(object, pathString, defaultValue = null) {
    // Coerce pathString to a string (even it turns into "[object Object]").
    const parts = `${pathString}`.split('.');
    const { length } = parts;
    let i = 0;

    // In case object isn't a real object, set it to undefined.
    let value = object === Object(object) ? object : undefined;

    while (value != null && i < length) {
        value = value[parts[i++]];
    }

    /**
     * lodash.get() returns the resolved value if
     * 1. iteration happened (i > 0)
     * 2. iteration completed (i === length)
     * 3. the value at the path is found in the data structure (not undefined). Note that if the path is found but the
     *    value is null, then defaultValue is returned.
     * If any of those checks fails, return the defaultValue param, if provided.
     */
    return i && i === length && value !== null && value !== undefined
        ? value
        : defaultValue;
}

export function _last<T>(arr: T[]): T {
    return arr.slice(-1)[0];
}

// A function that use to populate callbacks fields as a default values
export function _noop() {}

export function difference(_object, _base) {
    function changes(object, base) {
        return transform(object, (result, value, key) => {
            if (!isEqual(value, base[key])) {
                result[key] =
                    isObject(value) && isObject(base[key])
                        ? changes(value, base[key])
                        : value;
            }
        });
    }

    return changes(_object, _base);
}

export function falseNotZero(value) {
    return !value && value !== 0;
}

export const isEnumValue = (enumType, value) =>
    (Object.values(enumType) as string[]).includes(value);

export function mergeArrayFields<T extends object>(target: T, ...sources: T[]) {
    sources.forEach(source => {
        mergeWith(target, source, _mergeArrayFieldsCustomizer);
    });
    return target;
}
function _mergeArrayFieldsCustomizer<T>(targetValue: T, sourceValue: T) {
    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        targetValue.push(...sourceValue);
        return targetValue;
    }
}

export function isEmpty(obj) {
    return Object.keys(obj || {}).length === 0;
}
